import { render, staticRenderFns } from "./EditBrandCampaignBannerModal.vue?vue&type=template&id=33951d08&scoped=true&"
import script from "./EditBrandCampaignBannerModal.vue?vue&type=script&lang=js&"
export * from "./EditBrandCampaignBannerModal.vue?vue&type=script&lang=js&"
import style0 from "./EditBrandCampaignBannerModal.vue?vue&type=style&index=0&id=33951d08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33951d08",
  null
  
)

export default component.exports